import AppConstants from '@/appConstants';
import localStorageHelper from '@/helpers/local-storage-helper';

export default {
  namespaced: true,
  state: {
    filter: {
      type: AppConstants.NEWS_TYPE_LIST[0],
      searchQuery: '',
      newsId: null,
      origin: null,
      user: null,
      subject: null,
      dt_range: null,
      dt_create: null,
      dt_report: null,
      dt_end: null,
      active: AppConstants.ACTIVE.ALL,
      important: null,
      inLive: null,
      flashes: null,
      highlight: null,
      exclusive: null,
      mostReadDay: null,
      mostReadWeek: null,
      mostReadMonth: null,
      dt_from: null,
      dt_to: null,
      event_status: AppConstants.EVENT_STATUS.PUBLISHED
    },
    displayFilter: false,
    event_status: AppConstants.EVENT_STATUS_MENU.map((item) => ({ ...item })),
    currentEventStatus: {},
    draft_news: []
  },
  getters: {},
  mutations: {
    UPDATE_DISPLAY_FILTER(state, val) {
      state.displayFilter = val;
    },
    UPDATE_EVENT_STATUS(state, val) {
      state.event_status = val;
    },
    CURRENT_EVENT_STATUS(state, val) {
      state.currentEventStatus = val;
    },
    INIT_DRAFT_NEWS(state) { 
      state.draft_news = localStorageHelper.getDraftNews();
    },
    INSERT_DRAFT_NEWS(state, val) {
      const index = state.draft_news.findIndex(c => c.draftId === val.draftId);
      if (index < 0) {
        if (state.draft_news.length == 0) {
          val.draftId = 1;
        } else {
          val.draftId = state.draft_news[state.draft_news.length-1].draftId + 1;
        }
        state.draft_news.push(val);
      } else {
        state.draft_news[index] = val;
      }
      localStorageHelper.setDraftNews(state.draft_news);
    },
    UPDATE_DRAFT_NEWS(state, val) {
      const index = state.draft_news.findIndex(c => c.draftId === val.draftId);
      if (index >= 0) {
        state.draft_news[index] = val;
        localStorageHelper.setDraftNews(state.draft_news);
      }
    },
    REMOVE_DRAFT_NEWS(state, val) {
      state.draft_news.splice(state.draft_news.findIndex(c => c.draftId === val.draftId), 1);
      localStorageHelper.setDraftNews(state.draft_news);
    },
    CLEAR_FILTER(state) {
      state.filter.newsId = null;
      state.filter.origin = null;
      state.filter.user = null;
      state.filter.subject = null;
      state.filter.dt_range = null;
      state.filter.dt_create = null;
      state.filter.dt_report = null;
      state.filter.dt_end = null;
      state.filter.active = null;
      state.filter.important = null;
      state.filter.inLive = null;
      state.filter.flashes = null;
      state.filter.highlight = null;
      state.filter.exclusive = null;
      state.filter.mostReadDay = null;
      state.filter.mostReadWeek = null;
      state.filter.mostReadMonth = null;
      state.filter.dt_from = null;
      state.filter.dt_to = null;
      state.filter.event_status = AppConstants.EVENT_STATUS.PUBLISHED;
      state.filter.type = AppConstants.NEWS_TYPE_LIST[0];
      state.filter.searchQuery = '';
    },
    UPDATE_FILTER(state, val) {
      state.filter[val.field] = val.value;
    }
  },
  actions: {
    updateDisplayFilter({ commit }, payload) {
      commit('UPDATE_DISPLAY_FILTER', payload);
    },
    updateEventStatus({ commit }, payload) {
      commit('UPDATE_EVENT_STATUS', payload);
    },
    updateCurrentEventStatus({ commit }, payload) {
      commit('CURRENT_EVENT_STATUS', payload);
    },
    initDraftNews({ commit }, payload) {
      commit('INIT_DRAFT_NEWS', payload);
    },
    insertDraftNews({ commit }, payload) {
      commit('INSERT_DRAFT_NEWS', payload);
    },
    updateDraftNews({ commit }, payload) {
      commit('UPDATE_DRAFT_NEWS', payload);
    },
    removeDraftNews({ commit }, payload) {
      commit('REMOVE_DRAFT_NEWS', payload);
    },
    clearFilter({ commit }, payload) {
      commit('CLEAR_FILTER', payload);
    },
    updateFilter({ commit }, payload) {
      commit('UPDATE_FILTER', payload);
    },
  },
}
